import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

/** @jsx jsx */
import { forwardRef } from 'react';
import { css, jsx } from '@emotion/core';
import { layers } from '@atlaskit/theme/constants';
var primitiveCss = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  z-index: ", ";\n  cursor: default;\n"])), layers.tooltip());
var TooltipPrimitive = /*#__PURE__*/forwardRef(function TooltipPrimitive(_ref, ref) {
  var style = _ref.style,
      className = _ref.className,
      children = _ref.children,
      placement = _ref.placement,
      testId = _ref.testId,
      onMouseOut = _ref.onMouseOut,
      onMouseOver = _ref.onMouseOver,
      id = _ref.id;
  return (// eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
    jsx("div", {
      role: "tooltip",
      ref: ref,
      style: style,
      className: className,
      onMouseOut: onMouseOut,
      onMouseOver: onMouseOver,
      css: primitiveCss,
      "data-placement": placement,
      "data-testid": testId,
      id: id
    }, children)
  );
});
TooltipPrimitive.displayName = 'TooltipPrimitive';
export default TooltipPrimitive;